// src/components/BackgroundBlobs.jsx
import React from "react";

const BackgroundBlobs = () => {
  return (
    <div className="blob-bg">
      <div className="blob blob--pink blob--1"></div>
      <div className="blob blob--violet blob--2"></div>
      <div className="blob blob--blue blob--3"></div>
      <div className="blob blob--amber blob--4"></div>
    </div>
  );
};

export default BackgroundBlobs;
